import { useGetShopeeSticker, useGetSticker } from 'hooks/business/im/sticker';
import { useCallback } from 'react';

const useMustacheSticker2Url = (
  platform: General.PlatformUpperCase | false,
  region: General.UpperCaseRegion,
): [(str: string | undefined) => Promise<string | undefined>] => {
  const getSticker = useGetSticker();
  const getShopeeSticker = useGetShopeeSticker();

  const getStickerUrl = useCallback(
    async (str: string | undefined) => {
      if (str) {
        const [pid, sid] = str.split('@');
        if (platform === 'SHOPEE') {
          const sticker = await getShopeeSticker({
            region,
            pid,
            sid,
          });
          return sticker?.ossStickerAddress;
        }
        if (platform) {
          const sticker = await getSticker({ channel: platform, region, pid, sid });
          return sticker?.ossStickerAddress;
        }
      }
      return '';
    },
    [platform, region, getSticker, getShopeeSticker],
  );

  return [getStickerUrl];
};

export default useMustacheSticker2Url;
